import {AfterViewInit, Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {User} from "../../../shared/interface/user";
import {ReplaySubject} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormAddService} from "../../../shared/services/form-add.service";
import {HttpErrorResponse} from "@angular/common/http";
import {
  DICT_TYPE_FORM_ROW_STATUS,
  DictService,
 FORM_ROW_STATUS_LOSS, FORM_ROW_STATUS_SUCCESS,
} from "../../../shared/services/dict.service";
import {first} from "rxjs/operators";
import {AddPartnerToFormDialogComponent} from "../add-partner-to-form-dialog/add-partner-to-form-dialog.component";

@Component({
  selector: 'app-change-form-row-status-dialog',
  templateUrl: './change-form-row-status-dialog.component.html',
  styleUrls: ['./change-form-row-status-dialog.component.scss']
})
export class ChangeFormRowStatusDialogComponent implements OnInit, AfterViewInit {
  @Output() selectedUser: EventEmitter<User> = new EventEmitter<User>();
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  statusForm: FormGroup;
  statusValueControl: FormControl;
  tempUUID: string;
  processingRequest = false;
  formRowID: string;
  formData: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ChangeFormRowStatusDialogComponent>,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private formAddService: FormAddService,
    private dictService: DictService,
  ) {
    this.formRowID = this.data.uuid;
    this.statusForm = fb.group({
      status: this.statusValueControl = fb.control('', [Validators.required]),
    });
  }

  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
    this.tempUUID = this.data.uuid;
  }

  cancel(): void {
    this.dialogRef.close();
  }
  update(): void{
    this.formData = {...this.statusForm.value};
    this.formAddService.statusUpdate(this.formData, this.formRowID)
      .pipe(first())
      .subscribe(() => {
        this.snackBar.open('Pomyślnie zakutalizowano status', '', {duration: 2000});
        this.processingRequest = false;
        this.dialogRef.close(true);
      }, (error: HttpErrorResponse) => {
        this.snackBar.open('Przy aktualizacji wystąpił błąd', error.status.toString(), {duration: 2000});
        this.processingRequest = false;
        this.dialogRef.close(false);
      });
  }
  successChange(): void{
    this.dictService.getId(FORM_ROW_STATUS_SUCCESS, DICT_TYPE_FORM_ROW_STATUS)
      .subscribe((dictId: number) => {
        this.statusValueControl.setValue(dictId);
      });
    this.update();
  }
  failureChange(): void{
    this.dictService.getId(FORM_ROW_STATUS_LOSS, DICT_TYPE_FORM_ROW_STATUS)
      .subscribe((dictId: number) => {
        this.statusValueControl.setValue(dictId);
      });
    this.update();
  }
}
